const urlList = {
    GET_ALL_BLOGS: '/api/v1/oodles/getAllBlogs',
    GET_ALL_TAGS: '/api/v1/oodles/getAllTags',
    GET_ALL_RELATED_TAGS: '/api/v1/oodles/getAllRelatedTags',
    GET_ALL_RELATED_BLOGS: '/api/v1/oodles/getAllRelatedBlogs',
    GET_SINGLE_BLOG: '/api/v1/oodles/getSingleBlog',
    GET_RELATED_BLOG: '/api/v1/oodles/getAllRecommendedBlogs',
    GET_GLOBAL_SEARCH_BLOG: '/api/v1/oodles/getBlogByGlobalSearch',
    GET_DEPARTMENT: '/api/v1/getAllDepartmentWithSkill',
    GET_ALL_CATEGORY: '/api/v1/getCategory',
    GET_AOW_FILTERS: '/api/v1/oodles/getAowFilters',
    GET_BLOG_CONTRIBUTER: '/api/v1/oodles/getTechnicalContributorsDetails',
    GET_ALL_FAQ: '/api/v1/getAllFaq',
    SAVE_USER_JOURNEY : '/api/v1/saveClientJourneyBeforeLogin',
    CHECK_PARTNER: '/api/v1/oodles/getPartnerships',
    GET_PUBLISHED_BUSINESS_VERTICAL: '/api/v1/getPublishedBusinessVertical',
    GET_INDUSTRY_SECTORS: '/api/v1/getAllIndustrySectorWeCater',
}

export default urlList;


const socialLinks = {
    facebook: 'https://www.facebook.com/oodlesplatform/',
    twitter: 'https://twitter.com/oodlesplatform',
    linkedin: 'https://www.linkedin.com/company/oodlesplatform/',
    instagram: 'https://www.instagram.com/oodlesplatform/',
    youtube: 'https://www.youtube.com/channel/UCItMS41aSRykF1u7IA7wpJw',
};

export function redirectToSocial(platform: keyof typeof socialLinks) {
    if (typeof window !== 'undefined') {
        window.open(socialLinks[platform]);
    }
}
